


































































import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import RightDrawerHeader from "@/components/Pages/Scout/elements/RightDrawerHeader/index.vue";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import TextArea from "@/components/Atoms/Forms/TextArea/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import { occPrimary, occWhite } from "@/assets/styles/vars-for-script.scss";
import { getCharacterCount } from "@/helpers/string-helper";
import { MessageTemplate } from "@/components/Pages/Scout/MessageTemplates/MessageTemplateRightDrawer/MessageTemplatePanel/types";
import { TemplateRow } from "@/components/Pages/Scout/MessageTemplates/MessageTemplateList/MessageTemplateRow/types";
import { defaultTemplate } from "@/components/Pages/Scout/MessageTemplates/MessageTemplateRightDrawer/MessageTemplatePanel/consts";

export default defineComponent({
  name: "MessageTemplatePanel",
  components: {
    RightDrawerHeader,
    TextArea,
    OccButton,
    TextField
  },
  emits: ["cancel", "send"],
  props: {
    headerText: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "800px"
    },
    template: {
      type: Object as () => TemplateRow | null,
      default: null
    }
  },
  setup(props, { emit }) {
    const messageTemplateTitle = ref<string>(props.template?.title ?? "");
    const messageTemplateText = ref<string>(props.template?.message ?? "");

    watch(
      () => props.template,
      newValue => {
        messageTemplateTitle.value = newValue?.title ?? "";
        messageTemplateText.value = newValue?.message ?? "";
      }
    );

    const widthStyle = computed(() => {
      return { width: props.width };
    });

    const currentInputtedTitleCharactersCount = computed<number>(() => {
      return getCharacterCount(messageTemplateTitle.value);
    });

    const maxMessageTitleCount = 100;
    const isInvalidTitleText = computed<boolean>(() => {
      return currentInputtedTitleCharactersCount.value > maxMessageTitleCount;
    });

    const inputTitleError = computed(() => {
      if (isInvalidTitleText.value) {
        return `${maxMessageTitleCount}文字以内で入力してください`;
      }
      return "";
    });

    const currentInputtedMessageCharactersCount = computed<number>(() => {
      return getCharacterCount(messageTemplateText.value);
    });

    const maxMessageTextCount = 5000;
    const isInvalidMessageText = computed<boolean>(() => {
      return currentInputtedMessageCharactersCount.value > maxMessageTextCount;
    });

    const messageCharCounter = computed<string>(() => {
      return `${currentInputtedMessageCharactersCount.value} / ${maxMessageTextCount}文字`;
    });

    const inputMessageError = computed(() => {
      if (isInvalidMessageText.value) {
        return `${maxMessageTextCount}文字以内で入力してください`;
      }
      return "";
    });

    const sendButtonDisabled = computed<boolean>(() => {
      return (
        messageTemplateTitle.value === "" ||
        messageTemplateText.value === "" ||
        isInvalidTitleText.value ||
        isInvalidMessageText.value
      );
    });

    const handleInputtedMessageTitle = (value: string) => {
      messageTemplateTitle.value = value;
    };

    const handleInputtedMessageText = (value: string) => {
      messageTemplateText.value = value;
    };

    const handleClickedClose = () => {
      emit("cancel");
    };

    const handleClickedCancel = () => {
      emit("cancel");
    };

    const handleClickedSend = async () => {
      const messageTemplate: MessageTemplate = {
        id: props.template?.id ?? undefined,
        name: messageTemplateTitle.value,
        body: messageTemplateText.value
      };
      emit("send", messageTemplate);

      // NOTE: ドロワーが閉じる前に消えてしまうので、少し待ってから消す
      setTimeout(() => {
        messageTemplateTitle.value = "";
        messageTemplateText.value = "";
      }, 1000);
    };

    const handleClickedDefaultTemplate = () => {
      if (
        props.template !== null &&
        !confirm("入力中の内容は上書きされます。よろしいですか？")
      ) {
        return;
      }
      // 新規作成 or 編集中でアラートをOKした場合はサンプルを反映する
      messageTemplateTitle.value = defaultTemplate.title;
      messageTemplateText.value = defaultTemplate.text;
    };

    return {
      occPrimary,
      occWhite,
      widthStyle,
      messageTemplateTitle,
      messageTemplateText,
      sendButtonDisabled,
      messageCharCounter,
      handleInputtedMessageTitle,
      handleInputtedMessageText,
      handleClickedClose,
      handleClickedCancel,
      handleClickedSend,
      handleClickedDefaultTemplate,
      inputTitleError,
      inputMessageError,
      maxMessageTitleCount,
      maxMessageTextCount
    };
  }
});
